import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const PasswordStrengthRule = ({ isValid , highlightError , label  })=>/*#__PURE__*/ React.createElement("div", {
        className: "password-strength-rule"
    }, /*#__PURE__*/ React.createElement("div", null, isValid && /*#__PURE__*/ React.createElement(Icon, {
        className: "password-strength-rule__icon--valid",
        name: "checkmark-circle"
    }), !isValid && (highlightError ? /*#__PURE__*/ React.createElement(Icon, {
        className: "password-strength-rule__icon--invalid",
        name: "alert-circle"
    }) : /*#__PURE__*/ React.createElement(Icon, {
        className: "password-strength-rule__icon--unvalidated",
        name: "checkmark-circle"
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "password-strength-rule__label",
        role: !isValid && highlightError ? 'alert' : undefined
    }, label))
;

export { PasswordStrengthRule as default };
//# sourceMappingURL=PasswordStrengthRule.js.map
